"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _TagList = require("./TagList.style");

var _Icon = _interopRequireDefault(require("../Icon"));

var _helpers = require("../../utils/helpers");

var TagList = function TagList(_ref) {
  var tags = _ref.tags,
      dismissible = _ref.dismissible,
      onChangeCallback = _ref.onChangeCallback;
  return /*#__PURE__*/_react.default.createElement(_TagList.Tags, null, tags.map(function (tag) {
    return dismissible ? /*#__PURE__*/_react.default.createElement(_TagList.Tag, {
      key: (0, _helpers.getUniqueID)(tag),
      dismissible: dismissible,
      onClick: function onClick() {
        return onChangeCallback(tag);
      }
    }, /*#__PURE__*/_react.default.createElement(_rebass.Flex, {
      alignItems: "center"
    }, tag, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "X",
      size: "15px"
    }))) : /*#__PURE__*/_react.default.createElement(_TagList.Tag, {
      key: (0, _helpers.getUniqueID)(tag)
    }, tag);
  }));
};

TagList.propTypes = {
  tags: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  dismissible: _propTypes.default.bool,
  onChangeCallback: _propTypes.default.func
};
TagList.defaultProps = {
  dismissible: false,
  onChangeCallback: function onChangeCallback() {}
};
var _default = TagList;
exports.default = _default;